<template>
  <v-container fluid class="pa-4 rtl">
    <!-- Header -->
    <v-card class="header-card mb-4" elevation="2">
      <div class="d-flex align-center justify-space-between flex-wrap ga-3">
        <div>
          <div class="text-h5 font-weight-bold" style="color: #4a4f55">
            التقييم العام للمخاطر والأثر
          </div>
          <div class="text-body-2 text-grey-darken-1 mt-1">
            تقييم شامل لمستوى المخاطر وأثرها على الخدمات
          </div>
        </div>
        <v-btn
          prepend-icon="mdi-arrow-right"
          variant="text"
          style="color: #4a4f55"
          @click="showView('pillar-services')"
        >
          رجوع
        </v-btn>
      </div>
    </v-card>

    <!-- KPIs -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card danger">
          <div class="kpi-value">3</div>
          <div class="kpi-label">مرافق بمخاطر عالية</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">3</div>
          <div class="kpi-label">مخاطر متوسطة</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card success">
          <div class="kpi-value">3</div>
          <div class="kpi-label">مخاطر منخفضة</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card class="kpi-card warning">
          <div class="kpi-value">38%</div>
          <div class="kpi-label">متوسط درجة الخطر</div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Table -->
    <v-card class="table-card" elevation="1">
      <div class="table-header">مصفوفة المخاطر والأثر</div>
      <v-table class="custom-table">
        <thead>
          <tr>
            <th>المرفق</th>
            <th>مخاطر هيكلية</th>
            <th>مخاطر تشغيلية</th>
            <th>مخاطر مالية</th>
            <th>مخاطر كادر</th>
            <th>الأثر على المجتمع</th>
            <th>درجة الخطر الإجمالية/100</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in facilities" :key="item.name">
            <td class="font-weight-bold">{{ item.name }}</td>
            <td>
              <v-chip
                :color="riskColor(item.structural)"
                size="small"
                variant="flat"
                >{{ item.structural }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="riskColor(item.operational)"
                size="small"
                variant="flat"
                >{{ item.operational }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="riskColor(item.financial)"
                size="small"
                variant="flat"
                >{{ item.financial }}</v-chip
              >
            </td>
            <td>
              <v-chip
                :color="riskColor(item.staff)"
                size="small"
                variant="flat"
                >{{ item.staff }}</v-chip
              >
            </td>
            <td>{{ item.communityImpact }}</td>
            <td class="font-weight-bold" :class="scoreClass(item.score)">
              {{ item.score }}
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card>
  </v-container>
</template>

<script setup>
const facilities = [
  {
    name: "مستشفى الصداقة التعليمي",
    structural: "شديد",
    operational: "شديد",
    financial: "شديد",
    staff: "شديد",
    communityImpact: "847,400 مستفيد",
    score: 78,
  },
  {
    name: "مستشفى الأمراض النفسية",
    structural: "شديد",
    operational: "شديد",
    financial: "شديد",
    staff: "شديد",
    communityImpact: "125 مريض داخلي",
    score: 82,
  },
  {
    name: "مجمع الشيخ عثمان",
    structural: "متوسط",
    operational: "متوسط",
    financial: "متوسط",
    staff: "متوسط",
    communityImpact: "مجتمع واسع",
    score: 55,
  },
  {
    name: "مركز كود العثماني",
    structural: "متوسط",
    operational: "خفيف",
    financial: "خفيف",
    staff: "خفيف",
    communityImpact: "منطقة محدودة",
    score: 42,
  },
  {
    name: "مركز الممدارة",
    structural: "خفيف",
    operational: "خفيف",
    financial: "خفيف",
    staff: "خفيف",
    communityImpact: "منطقة محدودة",
    score: 25,
  },
  {
    name: "مركز المحاريق",
    structural: "متوسط",
    operational: "متوسط",
    financial: "متوسط",
    staff: "خفيف",
    communityImpact: "منطقة متوسطة",
    score: 48,
  },
  {
    name: "مركز عبد القوي",
    structural: "خفيف",
    operational: "خفيف",
    financial: "خفيف",
    staff: "خفيف",
    communityImpact: "منطقة محدودة",
    score: 22,
  },
  {
    name: "مركز ماري ستبوس",
    structural: "شديد",
    operational: "شديد",
    financial: "شديد",
    staff: "شديد",
    communityImpact: "42,000 امرأة",
    score: 88,
  },
  {
    name: "جمعية حقوق الطفل",
    structural: "خفيف",
    operational: "خفيف",
    financial: "خفيف",
    staff: "خفيف",
    communityImpact: "منطقة محدودة",
    score: 20,
  },
];

const riskColor = (value) => {
  if (value === "خفيف") return "green";
  if (value === "متوسط") return "orange";
  return "red";
};

const scoreClass = (value) => {
  if (value >= 70) return "text-red-darken-2";
  if (value >= 40) return "text-orange-darken-2";
  return "text-green-darken-2";
};

const showView = (view) => console.log("Go to:", view);
</script>

<style scoped>
.rtl {
  direction: rtl;
}

.header-card {
  border-right: 5px solid #4a4f55;
  border-radius: 18px;
  padding: 20px;
}

.kpi-card {
  border-radius: 18px;
  padding: 20px;
  text-align: center;
}

.kpi-value {
  font-size: 34px;
  font-weight: 800;
}

.kpi-label {
  margin-top: 6px;
  font-size: 13px;
}

.success {
  background: #e8f5ee;
  color: #1a7a4a;
}

.danger {
  background: #fdecea;
  color: #c0392b;
}

.warning {
  background: #fff4e5;
  color: #d4821a;
}

.table-card {
  border-radius: 18px;
  overflow: hidden;
}

.table-header {
  padding: 18px;
  font-size: 18px;
  font-weight: 700;
  color: #3a3f47;
  border-bottom: 1px solid #eee;
}

.custom-table {
  direction: rtl;
}

:deep(th) {
  font-weight: 800 !important;
  color: #3a3f47 !important;
  white-space: nowrap;
}

:deep(td) {
  font-size: 14px;
  white-space: nowrap;
}
</style>
